import { render } from "./FooterTop.vue?vue&type=template&id=24ba0743"
import script from "./FooterTop.vue?vue&type=script&lang=js"
export * from "./FooterTop.vue?vue&type=script&lang=js"

import "./FooterTop.vue?vue&type=style&index=0&id=24ba0743&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__